export default __webpack_public_path__ + "static/media/tour-1.6df91ad1.svg";